import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=060e2576&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&setup=true&"
export * from "./detail.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./detail.vue?vue&type=style&index=1&id=060e2576&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e2576",
  null
  
)

export default component.exports